import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const CustomTinyAreaChart = ({ selectedYear, data }) => {
  // Expect data = [{ month: 'Jan', revenue: 1234 }, ...]

  return (
    <ResponsiveContainer width="100%" height={250}>
      <AreaChart data={data || []}>
        <defs>
          <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0149AD" stopOpacity={0.4} />
            <stop offset="100%" stopColor="#0149AD" stopOpacity={0} />
          </linearGradient>
        </defs>

        <YAxis
          axisLine={false}
          tickLine={false}
          tickFormatter={(value) => (value === 0 ? "0" : `${value / 1000}K`)}
          tick={{
            fontSize: 12,
            fontFamily: "Be Vietnam Pro",
            fill: "#666",
          }}
        />
        <XAxis
          dataKey="month"
          axisLine={false}
          tickLine={false}
          tick={{
            fontSize: 12,
            fontFamily: "Be Vietnam Pro",
            fill: "#666",
          }}
        />
        <Tooltip formatter={(value) => `K${value.toLocaleString()}`} />
        <Area
          type="monotone"
          dataKey="revenue"
          stroke="#0149AD"
          strokeWidth={2}
          fill="url(#revenueGradient)"
          dot={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default CustomTinyAreaChart;